import { render, staticRenderFns } from "./GerenciarPpags.vue?vue&type=template&id=303d78a1&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./GerenciarPpags.vue?vue&type=style&index=0&id=303d78a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "303d78a1",
  null
  
)

export default component.exports